import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { FieldWrapper, ErrorBoundary } from 'common/components';
import { FieldList } from 'containers';

const Field = ({ showMapFlag, fields }) => {
  return (
    <ErrorBoundary>
      <FieldWrapper showMapFlag={showMapFlag} showFields>
        <FieldList fields={fields} />
      </FieldWrapper>
    </ErrorBoundary>
  );
};

Field.propTypes = {
  showMapFlag: PropTypes.bool,
  fields: PropTypes.arrayOf(PropTypes.object),
};

const mapState = ({ field, map }) => ({
  showMapFlag: field.showMapFlag,
  fields: map.fields,
});

export default connect(mapState)(Field);



// WEBPACK FOOTER //
// ./src/pages/Field/index.js